/**
 * 默认策略方法表 —— 所有允许被国家覆写的方法，必须在此声明
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：modulePage + Action（小驼峰，无连字符）
 * ═══════════════════════════════════════════════════════════
 *
 *  部分             含义                        示例
 * ─────────────────────────────────────────────────────────
 *  modulePageAction  模块+页面+动作拼接          printPrepareLabelData / addressMapSelection / loginAfterSuccess
 *
 * 多模块共用的策略，使用 "common" 前缀：
 *   例：commonFormatCurrency
 *
 * 约定：策略函数声明默认行为，国家层用同名方法覆盖
 */
import { NameEnum, UnionEnum, UrlEnum } from '@/utils/enums/Route'

type MenuItemIn = {
  id: string | number,
  svgIcon?: string,
  menuName: string,
  parentId: string | number,
  menuUrl?: string,
  stationType?: string[]
  children?: MenuItemIn[]
  icon?: string
}

const standardStrategies = {
  /**
   * 打印前的数据预处理
   * 不同国家打印面单格式可能不同
   */
  printPrepareLabelData(orderData: any): any {
    return orderData
  },

  /**
   * 地址选择后的数据映射
   * 不同国家地址结构不同（VN 省市县、MY 邮编优先等）
   */
  addressMapSelection(selected: any, _type: string): Record<string, any> {
    return selected
  },

  /**
   * 登录成功后的附加操作
   */
  async loginAfterSuccess(_context: Record<string, any>): Promise<void> {
    // 默认无操作
  },

  /**
   * 处理省市区地址列表 默认 省,市,区
   */
  addressColumnRender(record: any): any {
    const { province, city, area } = record
    return [province, city, area].filter((_) => _).join(', ') || '--'
  },
  /**
   * 个性化菜单
   */
  getPersonalizedMenu(stationType?: string): MenuItemIn[] {
    return []
  }
}

export type StandardStrategies = typeof standardStrategies
export default standardStrategies